import { Link } from "react-router-dom";
import { Phone, MessageCircle, CalendarClock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { pathFor } from "@/i18n/translations";
import { siteConfig, whatsappLink } from "@/config/site";

// Small inline WhatsApp link for service cards: prefills the message with the service name.
export const ServiceWhatsApp = ({ service, testid }) => {
  const { t } = useLang();
  return (
    <a
      href={whatsappLink(t.cta.whatsappService.replace("{service}", service))}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="inline-flex items-center gap-1.5 text-sm font-medium text-zinc-400 hover:text-[#25D366] transition-colors"
    >
      <MessageCircle size={15} style={{ color: "#25D366" }} /> {t.cta.askWhatsapp}
    </a>
  );
};

export const WhatsAppButton = () => {
  const { t } = useLang();
  return (
    <a
      href={whatsappLink(t.cta.whatsappMessage)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label="WhatsApp"
      className="on-dark hidden sm:flex fixed bottom-6 right-6 z-40 items-center justify-center w-14 h-14 rounded-full shadow-lg transition-transform hover:-translate-y-1"
      style={{ background: "#25D366" }}
    >
      <MessageCircle size={26} className="text-white" fill="white" />
    </a>
  );
};

export const MobileContactBar = () => {
  const { lang, t } = useLang();
  return (
    <div
      data-testid="mobile-contact-bar"
      className="on-dark sm:hidden fixed bottom-0 left-0 w-full z-50 grid grid-cols-3 bg-[#0A0A0C]/95 backdrop-blur-lg border-t border-white/10"
    >
      <a href={siteConfig.phoneHref} data-testid="bar-call" className="flex flex-col items-center gap-1 py-3 text-zinc-200 active:bg-white/5">
        <Phone size={20} style={{ color: "var(--accent)" }} />
        <span className="text-[11px] font-medium">{t.cta.call}</span>
      </a>
      <a href={whatsappLink(t.cta.whatsappMessage)} target="_blank" rel="noopener noreferrer"
        data-testid="bar-whatsapp" className="flex flex-col items-center gap-1 py-3 text-zinc-200 active:bg-white/5 border-x border-white/10">
        <MessageCircle size={20} style={{ color: "#25D366" }} />
        <span className="text-[11px] font-medium">{t.cta.whatsapp}</span>
      </a>
      <Link to={pathFor(lang, "contact")} data-testid="bar-appointment" className="flex flex-col items-center gap-1 py-3 text-zinc-200 active:bg-white/5">
        <CalendarClock size={20} style={{ color: "var(--accent)" }} />
        <span className="text-[11px] font-medium">{t.cta.appointment}</span>
      </Link>
    </div>
  );
};
